import type { FC } from 'react';
import React from 'react';

import { Inline, Box } from '@atlaskit/primitives';
import Image from '@atlaskit/image';

import { ArchiveAutomationRuleSettingsExample } from './ArchiveAutomationRuleSettingsExample';
import type { PremiumFeatureItem } from './PremiumFeatureTypes';
import { PremiumFeature } from './PremiumFeatureTypes';

export type PremiumFeatureTastingRightPanelProps = {
	featureShowing: PremiumFeature;
	featureDetailsMap: PremiumFeatureItem[];
	isAutomationPanel?: boolean;
};

export const PremiumFeatureTastingRightPanel: FC<PremiumFeatureTastingRightPanelProps> = ({
	featureShowing,
	featureDetailsMap,
	isAutomationPanel = false,
}) => {
	const featureDetail = featureDetailsMap.find(
		(featureItem) => featureItem.feature === featureShowing,
	);
	const featureImageLight = featureDetail?.imageLight;
	const featureImageDark = featureDetail?.imageDark;
	return (
		<>
			{featureShowing === PremiumFeature.AUTOMATION && (
				<Box paddingBlockStart="space.400">
					<ArchiveAutomationRuleSettingsExample isAutomationPanel={isAutomationPanel} />
				</Box>
			)}
			{featureShowing !== PremiumFeature.AUTOMATION && (
				<Inline alignBlock="center" grow="fill" spread="space-between">
					<Image
						src={featureImageLight}
						srcDark={featureImageDark}
						alt="premium feature image"
						height="229px"
					/>
				</Inline>
			)}
		</>
	);
};
